// Location Action Types
export const SET_LOCATION = "SET_LOCATION";
export const SET_LOCATION_PRESENT = "SET_LOCATION_PRESENT";
export const DETECT_LOCATION_REQUEST = "DETECT_LOCATION_REQUEST";
export const DETECT_LOCATION_SUCCESS = "DETECT_LOCATION_SUCCESS";
export const DETECT_LOCATION_FAILURE = "DETECT_LOCATION_FAILURE";

export const GET_LIVE_LOCATION_REQUEST = "GET_LIVE_LOCATION_REQUEST";
export const GET_LIVE_LOCATION_SUCCESS = "GET_LIVE_LOCATION_SUCCESS";
export const GET_LIVE_LOCATION_FAILURE = "GET_LIVE_LOCATION_FAILURE";
